import { render, staticRenderFns } from "./MediaSend.vue?vue&type=template&id=23ac2966&scoped=true&"
import script from "./MediaSend.vue?vue&type=script&lang=js&"
export * from "./MediaSend.vue?vue&type=script&lang=js&"
import style0 from "./MediaSend.vue?vue&type=style&index=0&id=23ac2966&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ac2966",
  null
  
)

export default component.exports